
/**
 * 트윗 유형
 */
export type GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwoTweetType = typeof GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwoTweetType[keyof typeof GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweets200PageAllOfThreeContentItemBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
